<template>
    <div class="wrapper-bg main-layout coffee">
        <div class="order-header">
            <a class="btn-back" @click="backHistory">
                <img src="@/assets/icon-back.svg" />
            </a>
            <div class="header-title">รายการสั่งซื้อ</div>
        </div>
        <ul class="order-tab">
            <li
                v-for="(item, index) of tablist"
                :key="index"
                @click="toggleTab(item)"
                class="tab-item"
                :class="{ active: activeTab === item }"
            >
                {{ item }}
            </li>
        </ul>
        <div class="order-body">
            <div
                v-if="activeTab === 'ยกเลิก-คืนเงิน'"
                class="underline-btn custom-margin"
                @click="showDetail()"
            >
                รายละเอียดการคืนเงิน
            </div>
            <OrderList :activetab="activeTab"></OrderList>
        </div>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>

<script>
import OrderList from "@/module/Order/component/OrderList.vue";
//core
import BzbsCustom from "@/core/Custom/service/BzbsCustom.js";
//mixin
import ModalMixin from "@/mixin/ModalMixin.js";
export default {
    name: "Order",
    mixins: [ModalMixin],
    components: {
        OrderList,
    },
    data() {
        return {
            tablist: [
                "สั่งสำเร็จ-รับที่ร้าน",
                "รับสินค้าแล้ว",
                "ยกเลิก-คืนเงิน",
            ],
            activeTab: "สั่งสำเร็จ-รับที่ร้าน",
            cancelDetail: {},
        };
    },
    created() {
        this.getBlob();
    },
    props: {},
    methods: {
        getBlob() {
            const url =
                "/nestle/nescafe_streetcafe/custom/nescafe_streetcafe_content.json";
            return new Promise((resolve, reject) => {
                BzbsCustom.apiGetCustom(url)
                    .then((response) => {
                        this.cancelDetail = response.cancelOrder_condition;
                        console.log(this.cancelDetail);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        backHistory() {
            this.$router.push("/profile");
        },
        toggleTab(item) {
            this.activeTab = item;
        },
        showDetail() {
            this.alertModal.setShowBtn(false);
            this.alertModal.setMsg(this.cancelDetail.desc);
            this.alertModal.setTitle(this.cancelDetail.title);
            this.alertModal.show();
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/module/Order/style/orderStyle.scss";
@import "@/style/_mixin.scss";
.order-tab {
    list-style: none;
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin: 5px 0 30px;
    .tab-item {
        padding: 10px 0;
        width: 7rem;
        color: $color-text;
        background-color: $color-light-grey-500;
        border-radius: 40px;
        font-size: 14px;
        text-align: center;
        &.active {
            color: #fff;
            background-color: $color-text;
        }
    }
}
.order-body {
    z-index: 10;
}
</style>
